<cdk-accordion-item #accordionItem="cdkAccordionItem" [expanded]="expanded" class="relative">
  <div class="absolute flex items-center justify-between" [class]="accordionItem.expanded ? 'w-full' : 'w-fit'">
    <div>
      <h4 class="typo-h4-semibold mb-1 text-text-primary">{{ 'support_welcome_title' | translate }}</h4>
      <p class="typo-h7-extralight text-text-secondary">{{ 'support_welcome_subtitle' | translate }}</p>
    </div>
    @if (accordionItem.expanded) {
      <div class="flex h-10 w-10 cursor-pointer items-center justify-center" (click)="accordionItem.close()">
        <svg-icon [key]="'px-16-arrow-up'" size="sm" class="text-primary-blue"></svg-icon>
      </div>
    }
  </div>

  <div
    class="relative grid grid-cols-4 gap-4 overflow-scroll drop-shadow-xl transition-all duration-300 ease-out"
    [class]="
      accordionItem.expanded
        ? 'mt-14 w-full max-sm:grid-cols-2 max-sm:grid-rows-2'
        : 'ml-auto h-10 w-fit cursor-pointer justify-end max-[1080px]:mt-14'
    "
    (click)="accordionItem.open()"
  >
    <div class="flex flex-col gap-2 rounded-2xl bg-background-white p-3" [class]="accordionItem.expanded ? 'h-[140px]' : 'h-fit'">
      <div class="flex gap-1">
        <svg-icon key="px-16-message" size="sm" class="min-h-4 min-w-4 text-primary-blue"></svg-icon>
        @if (accordionItem.expanded) {
          <h6 class="typo-h6-semibold text-text-primary">{{ 'support_send_message_title' | translate }}</h6>
        }
      </div>
      @if (accordionItem.expanded) {
        <p class="typo-h8-light grow font-normal text-text-secondary">{{ 'support_send_message_subtitle' | translate }}</p>
        <p class="typo-h8-bold inline-block h-4 w-fit rounded-md bg-secondary-green px-3 py-1 text-text-white shadow-item-status-green">
          {{ 'support_recommended' | translate }}
        </p>
      }
    </div>

    <div class="flex flex-col gap-2 rounded-2xl bg-background-white p-3" [class]="accordionItem.expanded ? 'h-[140px]' : 'h-fit'">
      <div class="flex gap-1">
        <svg-icon key="px-16-calendar" size="sm" class="min-h-4 min-w-4 text-primary-blue"></svg-icon>
        @if (accordionItem.expanded) {
          <h6 class="typo-h6-semibold text-text-primary">{{ 'support_schedule_time_title' | translate }}</h6>
        }
      </div>
      @if (accordionItem.expanded) {
        <p class="typo-h8-light grow font-normal text-text-secondary">{{ 'support_schedule_time_subtitle' | translate }}</p>
        <a [href]="bookTimeUrl" class="typo-h5-semibold w-fit text-text-blue no-underline">
          {{ 'support_book_time' | translate }}
        </a>
      }
    </div>

    <div class="flex flex-col gap-2 rounded-2xl bg-background-white p-3" [class]="accordionItem.expanded ? 'h-[140px]' : 'h-fit'">
      <div class="flex gap-1">
        <svg-icon key="px-16-collab" size="sm" class="min-h-4 min-w-4 text-primary-blue"></svg-icon>
        @if (accordionItem.expanded) {
          <h6 class="typo-h6-semibold text-text-primary">{{ 'support_send_email_title' | translate }}</h6>
        }
      </div>
      @if (accordionItem.expanded) {
        <p class="typo-h8-light grow font-normal text-text-secondary">{{ 'support_send_email_subtitle' | translate }}</p>
        <a
          target="_blank"
          [href]="'mailto:' + ('account_help_contact_email_action' | translate)"
          class="typo-h5-semibold w-fit text-text-blue no-underline"
        >
          {{ 'account_help_contact_email_action' | translate }}
        </a>
      }
    </div>

    <div class="flex flex-col gap-2 rounded-2xl bg-background-white p-3" [class]="accordionItem.expanded ? 'h-[140px]' : 'h-fit'">
      <div class="flex gap-1">
        <svg-icon key="px-24-phone" size="sm" class="min-h-4 min-w-4 text-primary-blue"></svg-icon>
        @if (accordionItem.expanded) {
          <h6 class="typo-h6-semibold text-text-primary">{{ 'support_call_us_title' | translate }}</h6>
        }
      </div>
      @if (accordionItem.expanded) {
        <div class="grow">
          <p class="typo-h8-light font-normal text-text-secondary">{{ 'support_call_us_subtitle' | translate }}</p>
          <p class="typo-h8-light text-text-tertiary">{{ 'support_business_hours' | translate }}</p>
        </div>
        <div class="flex flex-col gap-1">
          <a
            target="_blank"
            [href]="'tel:' + ('account_help_contact_phone_action' | translate)"
            class="typo-h5-semibold w-fit text-text-blue no-underline"
          >
            {{ 'account_help_contact_phone_action' | translate }}
          </a>
          <a
            target="_blank"
            [href]="'tel:' + ('account_help_contact_phone_action2' | translate)"
            class="typo-h5-semibold w-fit text-text-blue no-underline"
          >
            {{ 'account_help_contact_phone_action2' | translate }}
          </a>
        </div>
      }
    </div>
  </div>
</cdk-accordion-item>
